/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-11-14 09:25:32
 */
 
import Api from "src/util/api";
import {Result} from "src/types/base";
export declare namespace TendencyAnalyseDOI {

	export interface QueryMutStationResultI {
        name: string
        data: {timestamp: number, value: number}[]
	}

	export interface QueryMutStationParamsI  {
        cn?: string
        mns?: string[]
        component?: string
        end_time?: number
        start_time?: number
    }
    export interface QuerySingleStationResultI {
        name: string
        data: {timestamp: number, value: number}[]
	}

	export interface QuerySingleStationParamsI  {
        cn?: string
        mn?: string
        components?: string[]
        end_time?: number
        start_time?: number
    }
    

}
export default class TendencyAnalyseApi {
	/**
	 * 查询列表
	 * @param {DataViewDOI.QueryRowDataParamsI} params
	 * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
	 */
	static async searchMutStation(params: TendencyAnalyseDOI.QueryMutStationParamsI):Promise<Result<TendencyAnalyseDOI.QueryMutStationResultI[]>> {
		return Api.post('/monitor/single_component/multistation/query', params)
    }

    static async searchSingleStation(params: TendencyAnalyseDOI.QuerySingleStationParamsI):Promise<Result<TendencyAnalyseDOI.QuerySingleStationResultI[]>> {
		return Api.post('/monitor/more_component/single_station/query', params)
    }
   
}